module.exports = __webpack_public_path__ + "01_long_gold.0e1faaea.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer5/01_long_gold.png
// module id = PI9G
// module chunks = 0